import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
  static values = { id: Number }
  static targets = ["status", "list"]

  connect() {
    this.consumer = createConsumer()
    this.subscription = this.consumer.subscriptions.create(
      { channel: "ProcessingsChannel" },
      {
        received: (data) => this.handleMessage(data)
      }
    )
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  handleMessage(data) {
    const processing = data.processing
    if (!processing) return

    const row = document.querySelector(`[data-processing-id="${processing.id}"]`)
    if (!row) return

    // Update status badge
    const badge = row.querySelector('.badge')
    if (badge) {
      badge.className = `badge bg-${this.stateColor(processing.state)}`
      badge.textContent = processing.state
    }

    // Update progress
    const progress = row.querySelector('.files-progress')
    if (progress && processing.total_files) {
      progress.textContent = `${processing.files_done} / ${processing.total_files}`
      
      // Update progress bar if it exists
      const progressBar = row.querySelector('.progress-bar')
      if (progressBar) {
        const percent = Math.round((processing.files_done / processing.total_files) * 100)
        progressBar.style.width = `${percent}%`
      }
    }

    // Update current file
    const currentFileElem = row.querySelector('.current-file')
    if (currentFileElem) {
      currentFileElem.textContent = processing.current_file || ""
    }

    // Reload if needed
    if (processing.state === "finished" || processing.state === "error") {
      setTimeout(() => window.location.reload(), 2000)
    }
  }

  stateColor(state) {
    switch(state) {
      case "finished": return "success"
      case "error": return "danger"
      case "in_progress": return "primary"
      case "wait_start": return "warning"
      default: return "secondary"
    }
  }
}
